import { pageTypes } from 'config/pageTypes';

import heroImage from 'assets/images/sgp/SGPHero/small-self-storage-hero.webp';

import relatedContentImage3 from 'assets/images/psp/FeaturedContentImages/featured3.webp';
import relatedContentCheapest from 'assets/images/sgp/featuredContentImages/cheapest-storage-units-for-rent.webp';
import relatedContentDownsize from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage4.webp';
import relatedContentPrices from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage2.webp';

import storage5x5 from 'assets/images/sgp/SizeGuide/5x5.svg';
import storage5x10 from 'assets/images/sgp/SizeGuide/5x10.svg';
import { linkToOtherPSPsBlock } from './shared';

const heroContent = {
	title: 'Find Affordable Small Self Storage Units Near You',
	description:
		"Not every move calls for a massive storage unit, and not every budget has room for one either. Small self storage units are one of the most practical, affordable ways to handle life's overflow. Perfect for [clearing out a spare room](https://www.selfstorage.com/blog/why-your-house-feels-small-and-how-to-fix-it/), preparing for DIY projects, and taking care of everyday clutter - a small storage unit might be the solution you've been looking for. Take the guess work out of self storage rentals with SelfStorage.com.",
	image: heroImage,
	storageType: 'Small Self Storage',
	subheading: 'Find Budget Friendly Small Self Storage',
	CTAtext: 'Find Storage',
	searchPlaceholder: 'Enter ZIP Code or City Name',
};

const videoContent = {
	title: 'What is Small Self Storage?',
	background: 'blueWhiteGradient',
	pageType: pageTypes.SGP,
	modules: [
		{
			type: 'video',
			props: {
				pageType: pageTypes.SGP,
				content: {
					title: 'What is Small Self Storage?',
					subtitle: 'What Are Small Self Storage Units?',
					description:
						"Small self storage units typically range from 5x5 to 5x10 feet, covering 25 to 50 square feet of storage space. These units are among the most popular self storage options, as they're both budget-friendly and versatile in their use.",
					videoSrc:
						'https://www.youtube.com/embed/Z77b96EEoFk?rel=0&playsinline=1&enablejsapi=1',
				},
			},
		},
	],
};

const sizeChartContent = [
	{
		type: 'cardStrip',
		props: {
			heading: 'Small Storage Unit Size Comparison',
			pageType: pageTypes.SGP,
			description:
				"Here's what you can expect from each of these small self storage units:",
			cardData: [
				{
					title: '5x5',
					size: '25 ft² | 200 ft³',
					content:
						'**Best For:**\n\n Seasonal items, small furniture pieces, personal document storage, off-season clothing. ',
					imageSrc: storage5x5,
					contentAlign: 'text-left sgp',
				},
				{
					title: '5x10',
					size: '50 ft² | 400 ft³',
					content:
						'**Best For:**\n\n Contents of a studio apartment, kitchen appliance set, business inventory, sporting goods.',
					imageSrc: storage5x10,
					contentAlign: 'text-left sgp',
				},
			],
		},
	},
];

const pricingContent = [
	{
		type: 'sizeComparisonSection',
		props: {
			content: {
				title: 'Small Self Storage Unit Pricing Overview',
				description:
					"Affordable small self storage units are easier to find than you might think. We've put together a quick pricing guide directly from our network of small self storage units so you can make the best choice for your needs. [Prices may vary based on location, amenities, and seasonal demand](https://www.selfstorage.com/blog/storage-unit-prices/) - so be sure to shop and compare with our self storage comparison tool.",
				image: '',
				contentdec: '',
			},
			storageData: [
				{
					size: '5x5',
					heading: "5' Wide x 5' Long",
					desc: [
						'**Monthly Average:** $32.08 (2026)\n\n**Unit + Climate Control:** Expect a 10-20% increase in monthly cost',
					],
				},
				{
					size: '5x10',
					heading: "5' Wide x 10' Long",
					desc: [
						'**Monthly Average:** $47.60 (2026)\n\n**Unit + Climate Control:** Expect a 10-20% increase in monthly cost',
					],
				},
			],
		},
	},
];

const howToUseContent = [
	{
		type: 'content',
		props: {
			title: 'How to Make the Most of a Small Self Storage Unit',
			description:
				"Want to make the most out of your investment in a small self storage unit? We've put together some [practical tips to help keep you, and your unit, organized](https://www.selfstorage.com/blog/how-to-organize-a-storage-unit/). Here's how to make every square foot count:",
			theme: 'dark',
			contentType: 'column-type',
			content: [
				"### Before You Load Up\n\n- **Take stock of what you're storing.** Grouping items by category (like seasonal, furniture, documents, and fragile) before you start packing makes loading and unloading a whole lot easier.\n- **Use uniform boxes when you can.** Consistent container sizes stack more securely and leave less wasted space between items.\n- **Disassemble what you can.** Bed frames, bookshelves, and table legs take up less square footage when disassembled. Store the hardware in a labeled bag taped to the piece it belongs to.",
				"### When You're Loading\n\n- **Heavy items go on the bottom.** Appliances, book boxes, and furniture bases form a stable foundation for lighter, more fragile items on top.\n- **Work from the back wall forward.** Place items you won't need regular access to toward the back, and keep everyday or frequently needed items near the door.\n- **Go vertical.** Stack boxes and bins as high as the unit (and your stacking confidence) allows. A freestanding shelf unit can help organize smaller items and free up floor space.",
				"### Staying Organized Long-Term\n\n- **Label all four sides of every box.** You'll thank yourself the first time you're looking for something specific without having to unstack everything.\n- **Leave a center aisle if your unit size allows.** Even a narrow walkway makes a big difference when you need to get to something in the back.\n- **Photograph your unit after loading.** A quick picture of what's where can save you a lot of time on future visits.",
			],
		},
	},
];

const reviewsContent = {
	headerTitle: '',
	reviews: [
		{
			id: 'small-self-storage-review-1',
			title: 'Rick was cordial and explained how the...',
			stars: 5,
			text: 'Rick was cordial and explained how the charges were broken down. We were only looking for a small unit so before we committed he showed us the two smallest units and let us decide which would meet our needs.',
			customerName: 'Thomas Crossman',
			date: '2026-01-09',
			link: 'https://www.trustpilot.com/reviews/6961205cc6f6134b7e61883b',
		},
		{
			id: 'small-self-storage-review-2',
			title: 'Courteous and helpful',
			stars: 5,
			text: "Courteous and helpful. Didn't try to upsell me but made suggestions. On top of it even though I only needed a small unit. Thanks guys!",
			customerName: 'Consumer',
			date: '2025-04-15',
			link: 'https://www.trustpilot.com/reviews/67fee7559ffc9b9578e66076',
		},
		{
			id: 'small-self-storage-review-3',
			title: 'Make reservations was so easy!',
			stars: 5,
			text: 'I needed a small climate controlled storage space in a hurry and Self Storage had the best price.',
			customerName: 'Kem Washington',
			date: '2024-05-14',
			link: 'https://www.trustpilot.com/reviews/6643ccb7603d6d580747ba61',
		},
		{
			id: 'small-self-storage-review-4',
			title: 'Had a small unit we were looking for',
			stars: 5,
			text: 'Had a small unit we were looking for. Brent was very personable and efficient. Location is clean and secure',
			customerName: 'Michael Maddox',
			date: '2022-05-16',
			link: 'https://www.trustpilot.com/reviews/6282a1d9604d19208431ddd4',
		},
	],
};

const faqSectionContent = {
	header: 'Frequently Asked Questions',
	image: storage5x5,
	description:
		'These are the most common questions we get asked when people are trying to decide between storage unit sizes.',
	faqs: [
		{
			question: 'How big is a small self storage unit?',
			answer: "Small self storage units are most commonly 5x10 feet, which is about the size of a large walk-in closet or a small bathroom. You get 50 square feet of floor space to work with, plus vertical room to stack. It's one of the most versatile sizes available and a go-to for people who need more than a closet but don't want to pay for more space than necessary.",
		},
		{
			question: 'What fits in a 5x10 self storage unit?',
			answer: "A 5x10 unit can hold the contents of a studio apartment or a single bedroom. Think a mattress set, dresser, small sofa, a few boxes, and some odds and ends. It's also a popular choice for clearing out a home office, storing seasonal gear like bikes or skis, or holding onto furniture during a renovation.",
		},
		{
			question:
				'Is a 5x10 storage unit big enough for a one-bedroom apartment?',
			answer: "It can be, depending on how much furniture you have and how efficiently you pack. A 5x10 is a comfortable fit for a lightly furnished one-bedroom: a bed frame, mattress, dresser, small couch, and boxes of personal items. If your space is fully furnished or you're storing larger pieces, you may want to consider a medium unit to give yourself a little more breathing room.",
		},
		{
			question: 'How much does a small self storage unit cost?',
			answer: "Pricing varies by location, facility, and features like climate control or drive-up access, but small units are generally one of the more affordable options at most facilities. It's a good idea to compare a few options in your area and factor in any move-in specials or discounts - many facilities offer flexible pricing for new renters. You can do this directly from our site, just enter your zip code to find available units in your area, and shop around for the best price.",
		},
		{
			question: 'Do I need climate control for a small storage unit?',
			answer: "It depends on what you're storing. If your unit will hold furniture, electronics, documents, artwork, or anything sensitive to temperature and humidity swings, climate control is worth the investment. If you're storing hardier items like tools and outdoor gear, a standard unit will work for your needs.",
		},
	],
};

const relatedContent = {
	heading: 'Related Resources',
	type: 'unitCards',
	id: 'small-storage-related-content',
	data: {
		slug: 'small-storage-related-content',
		unitCards: [
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/self-storage-unit-size-guide-2/',
				layout: false,
				plain: true,
				image: relatedContentImage3,
				content:
					'Self Storage Size Guide: Finding the Perfect Storage Unit Size',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/cheapest-storage-unit-prices/',
				layout: false,
				plain: true,
				image: relatedContentCheapest,
				content: 'What Is The Cheapest Storage Unit You Can Rent?',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/storage-unit-prices/',
				layout: false,
				plain: true,
				image: relatedContentPrices,
				content: 'Storage Unit Prices: How Much Is a Storage Unit?',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/how-storage-reduces-cost-of-living/',
				layout: false,
				plain: true,
				image: relatedContentDownsize,
				content:
					'The Benefits of Downsizing Your Home: How to Reduce the Cost of Living with Self Storage',
			},
		],
	},
};

export const SmallSelfStorageContent = {
	type: 'small-self-storage',
	pageType: pageTypes.SGP,
	reviews: reviewsContent.reviews,
	sections: [
		{
			title: 'Small Self Storage Hero',
			background: 'default',
			pageType: pageTypes.SGP,
			modules: [
				{
					type: 'hero',
					id: 'small-self-storage-hero',
					props: {
						content: heroContent,
						pageType: pageTypes.SGP,
						additionalProps: {
							heading: {
								size: 'large',
								color: 'white',
								weight: 'ultraBold',
							},
						},
					},
				},
			],
		},
		videoContent,
		{
			title: 'Small Storage Unit Size Comparison',
			noPaddingTop: true,
			modules: sizeChartContent,
		},
		{
			title: 'Small Self Storage Pricing',
			pageType: pageTypes.SGP,
			noPadding: true,
			modules: pricingContent,
		},
		{
			title: 'How to Make the Most of a Small Self Storage Unit',
			background: 'bgImage',
			pageType: pageTypes.SGP,
			modules: howToUseContent,
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			pageType: pageTypes.SGP,
			modules: [
				{
					type: 'reviews',
					title: 'Reviews Section',
					slug: 'small-self-storage-reviews',
					props: {
						pageType: pageTypes.SGP,
						reviewsData: reviewsContent,
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: faqSectionContent,
					},
				},
			],
		},
		{
			title: 'Related Content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: relatedContent,
					},
				},
			],
		},
		linkToOtherPSPsBlock,
		{
			title: 'Storage Near You',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'StorageSize',
					},
				},
			],
		},
	],
};
